import '../css/EspaciosComunes.css';

function Tarifas() {
  return (
    <section id="tarifas" className="tarifas-section">
      <span className="eyebrow">PLANIFICÁ TU VISITA</span>
      <h2 className="tarifas-title">Tarifas 2026/2027</h2>
      <p className="section-description">Encontrá la opción que mejor se adapta a tu viaje.</p>

      <div className="tarifas-table-container" role="region" aria-label="Tarifas por tipo de habitación" tabIndex="0">
        <table className="tarifas-table">
          <thead>
            <tr>
              <th scope="col">Temporada</th>
              <th>Single</th>
              <th>Single Deluxe</th>
              <th>Doble</th>
              <th>Doble Deluxe</th>
              <th>Triple Deluxe</th>
              <th>Cuádruple Deluxe</th>
              <th>Apart<br/>(p/ persona)</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Octubre/noviembre</td>
              <td>$33.000</td>
              <td>$39.000</td>
              <td>$44.000</td>
              <td>$52.000</td>
              <td>$79.000</td>
              <td>$105.000</td>
              <td>$28.000</td>
            </tr>
            {[
              ['Diciembre', 38000, 45000, 50000, 60000, 90000, 112000, 30000],
              ['Enero (1 al 5 inclusive)', 40000, 47000, 54000, 64000, 95000, 123000, 32000],
              ['Enero (6 al 13 inclusive)', 45000, 54000, 60000, 72000, 107000, 140000, 36000],
              ['Enero (14 al 31 inclusive)', 50000, 60000, 67000, 80000, 120000, 157000, 40000],
              ['Carnaval (06/02 al 09/02 inclusive)', 50000, 60000, 67000, 80000, 120000, 157000, 40000],
              ['Febrero (hasta 03/03 inclusive), excepto carnaval', 45000, 54000, 60000, 72000, 107000, 140000, 36000],
              ['Marzo (del 1/03 al 23/03 inclusive)', 38000, 45000, 50000, 60000, 90000, 112000, 30000],
              ['Semana Santa (del 24/03 al 27/03 inclusive)', 45000, 54000, 60000, 72000, 107000, 140000, 36000],
            ].map(([temporada, ...valores]) => (
              <tr key={temporada}>
                <td>{temporada}</td>
                {valores.map((valor, index) => (
                  <td key={index}>${valor.toLocaleString('es-AR')}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="rates-note"><span>Precio de lista. 10 % de descuento abonando de contado en efectivo. Desayuno incluido. Consultá disponibilidad para tus fechas.</span><a className="text-link" href="#consulta">Consultar estadía ↗</a></div>
    </section>
  );
}

export default Tarifas;
